/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { styled, Box, Button, MenuList } from "@mui/material";
import { viewTypographyStyles } from "../reports/styles";

export const ConfiguredDiscountPage = styled('div')({
  height: '100%',
  width: '100%',
  overflowY: 'scroll',
  overflowX: 'hidden',
})

export const filterContinerStyle = {
  display: "flex",
  flexDirection: { xs: "column", md: "row" },
  justifyContent: "space-between",
  alignItems: { xs: "flex-start", md: "center" },
  gap: { xs: 2, md: 0 }
}

export const filterSectionStyle = {
  display: "flex",
  flexDirection: { xs: "column", sm: "row" },
  gap: { xs: 2, sm: "18px" },
  flexWrap: "wrap",
  width: { xs: "100%", md: "auto" },
  flex: 1
}

export const typographyStyle = {
  ...viewTypographyStyles,
  alignSelf: { xs: "flex-start", sm: "center" },
  whiteSpace: "nowrap"
}

export const menuPropStyle = {
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "left",
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "left",
  },
  PaperProps: { sx: { maxHeight: "40vh", minWidth: '240px' } },
  autoFocus: false,
  MenuListProps: { sx: { pt: 0 } },
}

export const statusMenuPropStyle = {
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "left",
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "left",
  },
  PaperProps: { sx: { maxHeight: "40vh", width: '240px' } },
  autoFocus: false,
}

export const actionSectionStyle = {
  display: "flex",
  alignItems: "center",
  gap: 1,
  alignSelf: { xs: "flex-start", md: "center" },
  mt: { xs: 1, md: 0 },
  width: { xs: "100%", md: "auto" },
  justifyContent: { xs: "flex-start", md: "flex-end" }
}

export const FetchButtonContainer = styled('div')({
  display: 'flex',
  justifyContent: 'end',
  alignItems: 'center',
  marginBottom: "10px",
  gap: '10px',
})

export const StatusContainer = styled(Box)(({ action }) => ({
  height: "24px",
  width: "100px",
  borderRadius: "6px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: `${getColorCode(action)}20`,
  color: getColorCode(action),
  fontSize: '0.775rem',
}));

const getColorCode = (action) => {
  switch (action) {
    case 'managed':
      return '#39cd80'
    case 'unclassified':
      return '#61b2fa'
    case 'unmanaged':
      return '#f64246'
  }
}

export const ClassificationActionButton = styled(Button)({
  '&:hover': {
    backgroundColor: '#395bbd !important',
    boxShadow: 'none !important',
  },
  textTransform: 'none',
  backgroundColor: '#395bbd',
  boxShadow: 'none',
})

export const StyledStatusButton = styled(Button)({
  '&:hover': {
    backgroundColor: 'transparent'
  },
  textTransform: 'none',
  minWidth: 'unset',
  padding: 0,
  justifyContent: 'flex-start'
})

export const StatusMenuList = styled(MenuList)({
  padding: '6px',
})

export const statusPopoverPaperStyle = {
  mt: '6px',
  borderRadius: '10px',
  boxShadow: '0 12px 30px rgba(15, 23, 42, 0.14)',
  border: '1px solid #e5e7eb',
  minWidth: '132px',
}

export const statusMenuItemStyle = {
  borderRadius: '8px',
  fontSize: '0.8125rem',
  minHeight: '34px',
  px: 1.25,
  textTransform: 'none',
}
